import {
  LoadMessageDirection,
  MessageRecord,
  MessageRecordPlaceholder,
  MessageRecordType,
} from '../../../../../../server-services/query-records/room-records';
import { ResponseMergerHandler } from '../../../cache-logic-interface';

export let customRoomMessageQueryMerger: ResponseMergerHandler = function (
  cache,
  request,
  response: (MessageRecordPlaceholder | MessageRecord)[]
) {
  // quick access to message
  if (!cache.getCacheData('messages')[request.variables.roomId]) {
    cache.getCacheData('messages')[request.variables.roomId] = {};
  }

  /*if (variables.pivot == null) {
          cache.set(cacheKey, response);
        } else {
          cache.set(cacheKey, cache.get(cacheKey).concat(response));
        }*/
  let cacheKey = cache.getCacheLogic().makeCacheDataPath(request);

  let cachedMessages: any[] = cache.getCacheData(cacheKey);

  if (!cachedMessages?.length) {
    cachedMessages = [
      { type: MessageRecordType.END },
      { type: MessageRecordType.VOID },
      { type: MessageRecordType.END },
    ];
    cache.setCacheData(cacheKey, cachedMessages);
  }

  // init cachedMessages
  response.forEach((msg) => {
    if ((<MessageRecord>msg)?.id) {
      cache.getCacheData('messages')[request.variables.roomId][(<MessageRecord>msg)?.id] = msg;
    }
  });

  messageStreamMerger(cachedMessages, request, response);

  // sets beforeMsgId and afterMsgId on voids
  messageStreamVoidFixer(cachedMessages);
};

export const messageStreamVoidFixer = (cachedMessages: any[]) => {
  for (let i = 0; i < cachedMessages.length; i++) {
    if (cachedMessages[i]?.type === MessageRecordType.VOID) {
      cachedMessages[i].beforeMsgId = cachedMessages[i - 1]?.id;
      cachedMessages[i].afterMsgId = cachedMessages[i + 1]?.id;
    }
  }
};

export const messageStreamMerger = (cachedMessages: any[], request, response) => {
  const pivot = request.variables?.pivot;

  if (request.variables?.direction === LoadMessageDirection.BEFORE) {
    mergeMessageBefore(response, cachedMessages, pivot);
  } else {
    // request.variables?.direction === 'after' // as default
    mergeMessageAfter(response, cachedMessages, pivot);
  }
};

const mergeMessageBefore = (response, cachedMessages, pivot) => {
  //   direction=BEFORE / after=True means:
  //       - newer items following older ones
  //       - response items start from but not including the pivot item
  //       - pivot=None means to start from the very beginning
  let pivotIndex = cachedMessages.length - 1;
  if (pivot) {
    const foundIndex = cachedMessages.findIndex((msg) => msg.id <= pivot);
    if (foundIndex > 0) {
      pivotIndex = foundIndex;
    }
  }
  if (!response?.length) {
    // There are absolutely no messages before pivot if an empty response is received, so clear everything.
    cachedMessages.splice(1, pivotIndex - 1);
  } else {
    let spliceStartIndex = pivotIndex;
    const spliceStartId = response[response.length - 1].id;
    for (let i = pivotIndex - 1; i > 0; i--) {
      if (cachedMessages[i]?.type === MessageRecordType.VOID) continue;
      if (spliceStartId >= cachedMessages[i]?.id) {
        spliceStartIndex = i;
      } else {
        break;
      }
    }
    const overlap = pivotIndex - spliceStartIndex;
    cachedMessages.splice(spliceStartIndex, overlap, ...response.reverse());
    if (overlap === 0 && cachedMessages[pivotIndex - 1]?.type !== MessageRecordType.VOID) {
      cachedMessages.splice(pivotIndex, 0, { type: MessageRecordType.VOID });
    }
  }
};

const mergeMessageAfter = (response, cachedMessages, pivot) => {
  //   direction=AFTER / after=False means:
  //       - older items following newer ones
  //       - response items start from but not including the pivot item
  //       - pivot=None means to start from the very end
  let pivotIndex = 0;
  if (pivot) {
    const foundIndex = cachedMessages.findLastIndex((msg) => msg.id >= pivot);
    if (foundIndex > 0 && foundIndex < cachedMessages.length - 1) {
      pivotIndex = foundIndex;
    }
  }
  pivotIndex++;
  if (!response?.length) {
    // There are absolutely no messages after pivot if an empty response is received, so clear everything.
    cachedMessages.splice(pivotIndex, cachedMessages.length - (pivotIndex + 1));
  } else {
    let spliceEndIndex = pivotIndex;
    const spliceEndId = response[response.length - 1].id;
    for (let i = pivotIndex; i < cachedMessages.length - 1; i++) {
      if (cachedMessages[i]?.type === MessageRecordType.VOID) continue;
      if (spliceEndId <= cachedMessages[i]?.id) {
        spliceEndIndex = i + 1;
      } else {
        break;
      }
    }
    const overlap = spliceEndIndex - pivotIndex;
    cachedMessages.splice(pivotIndex, overlap, ...response);
    if (overlap === 0 && cachedMessages[pivotIndex + response.length]?.type !== MessageRecordType.VOID) {
      cachedMessages.splice(pivotIndex + response.length, 0, { type: MessageRecordType.VOID });
    }
  }
};
